<template>
  <div style="text-align: center" :style="{ padding: ($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) ? '60px 1%' : '60px 15%' }">
    <!-- Heading -->
    <p class="display-1 font-weight-medium verification-heading">
      Die Seite konnte nicht gefunden werden
    </p>
    <!-- Subheading -->
    <p class="title font-weight-regular px-10">
      Entweder funktioniert der von dir angeklickte Link nicht oder die Seite wurde entfernt.
    </p>
    <v-icon style="width: 250px; height: 250px">$candle-sad</v-icon>
    <!-- Global Search -->
    <div class="headline font-weight-medium" style="margin-top: 5%">
      Nach einer bestimmten Person oder Trauerfällen in einer Region suchen
      <div class="search-field">
        <v-container>
          <v-row>
            <v-col cols="12" lg="9">
              <v-text-field
                v-model="searchString"
                outlined
                rounded
                class="title font-weight-regular"
                placeholder="Name, Ort oder Stadt eingeben..."
                @keydown.enter="search"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="3">
              <unvergessen-button style="min-height: 55px; border-radius: 60px; min-width: 200px" @click="search">
                <v-icon size="30">mdi-magnify</v-icon>
                Suchen
              </unvergessen-button>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchString: ''
    }
  },
  methods: {
    search () {
      this.$router.push({ name: 'Search', query: { str: this.searchString } })
    }
  }
}
</script>

<style scoped>
  .search-field {
    margin-top: 2%
  }
</style>
